import useBenguide from 'hooks/benguide';
import { useAppDispatch } from 'hooks/redux';
import UPClient from 'modules/clients/UPClient/UPClient';
import useUPClient from 'modules/clients/UPClient/useUPClient';

import {
  HOLIDAY_AND_TIMEOFF_CHANNEL,
  RELOAD_HOLIDAY_AND_TIMEOFF_PLAN_LIST,
  RELOAD_HOLIDAY_AND_TIMEOFF_SECTION,
  BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
  BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
  BENGUIDE_NOTIFICATIONS,
} from 'modules/clients/UPClient/UPClientConst';
import {
  fetchHolidayAndTimeOffPlanList,
  reloadBenefitAndTimeOffSection,
} from 'modules/holidaysAndTimeOff/slices/holidayAndTimeOffSlice';

const HolidayAndTimeOffPlansChannel = () => {
  const dispatch = useAppDispatch();
  const benguide = useBenguide();
  const upClient = useUPClient();
  return (
    <UPClient
      channel={HOLIDAY_AND_TIMEOFF_CHANNEL}
      subscribe={(event: string) => {
        switch (event) {
          case RELOAD_HOLIDAY_AND_TIMEOFF_PLAN_LIST:
            dispatch(
              fetchHolidayAndTimeOffPlanList(
                benguide.employerId,
                benguide.planYearId,
                benguide.benefitClasses
              )
            );
            break;
          case RELOAD_HOLIDAY_AND_TIMEOFF_SECTION:
            dispatch(
              reloadBenefitAndTimeOffSection(
                benguide.masterId,
                benguide.latestRevision
              )
            );
            break;
          case BENGUIDE_NOTIFICATION_HIDE_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
              data: {},
            });
            break;
          case BENGUIDE_NOTIFICATION_SHOW_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
              data: {},
            });
            break;
        }
      }}
    />
  );
};

export default HolidayAndTimeOffPlansChannel;
